import React from "react";
import "../../style/parmmagazine.css";

import infoIcon from "../../parm_assets/tree_icons.png";

const img1 = "https://ik.imagekit.io/axiomhives/parm_assets/arborica/arborica-1.jpg?updatedAt=1769929457224"; // replace with your actual image paths
const img2 = "https://ik.imagekit.io/axiomhives/parm_assets/arborica/arborica_2.png?updatedAt=1769929462710";
const img3 = "https://ik.imagekit.io/axiomhives/parm_assets/arborica/arborica_3.png?updatedAt=1769929462240";
const img4 = "https://ik.imagekit.io/axiomhives/parm_assets/arborica/arborica_issue4.jpeg"; // replace with your actual image paths
const img5 = "https://ik.imagekit.io/axiomhives/parm_assets/arborica/arborica_issue5.jpeg";

const ArboricaAll = () => {
  const magazines = [
    {
      id: 1,
      title: "Issue 1",
      date: "Issue 1, Sept 2019",
      image: img1,
      src: "https://anyflip.com/opzgt/szqp/",
    },
    {
      id: 2,
      title: "Issue 2",
      date: "Issue 2, June 2020",
      image: img2,
      src: "https://online.anyflip.com/opzgt/zynb/mobile/"
    },
    {
      id: 3,
      title: "Issue 3",
      date: "Issue 3, June 2023",
      image: img3,
      src: "https://online.anyflip.com/riicm/xshr/mobile/"
    },
    {
      id: 4,
      title: "Issue 4",
      date: "Issue 4, July 2022",
      image: img4,
      src: "#"
    },
    {
      id: 5,
      title: "Issue 5",
      date: "Issue 5, 2024",
      image: img5,
      src: "#"
    },
  ];

  return (
    <section className="magazine-section">
      <div className="magazine-header">
        <div>
          <p className="magazine-subtitle">
            <img src={infoIcon} alt="icon" className="tree-icon" />
            ARBORICA</p>
          <h2 className="magazine-title">Uncover PArM’s Magazines</h2>
        </div>
        {/* <a href="/arboricaAll" className="explore-btn-new-page">
        <button className="all-btn">All Magazines →</button>
        </a> */}
      </div>

      <div className="magazine-grid">
        {magazines.map((item) => (
          <div key={item.id} className="magazine-card">
            <img src={item.image} alt={item.title} className="magazine-img" />
            <div className="magazine-info">
              <div>
                <h3>{item.title}</h3>
                <p>{item.date}</p>
              </div>
              <button className="magazines-arrow-btn"
              onClick={() => item.src && window.open(item.src, "_blank", "noopener,noreferrer")}
                aria-label={`Read ${item.title}`}
              >→</button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ArboricaAll;
